import { Injectable } from '@angular/core';
import API from '../../common/services/api.config.json';
import { HttpClient } from '@angular/common/http';
import { constant } from 'app/modules/common/helpers/constant';
import { BehaviorSubject, Observable,Subscription,pipe } from 'rxjs'
import { RestResponse } from 'app/modules/common/entities/rest.response.model';

@Injectable({providedIn:'root'})
export class DiagnosisService {

  constructor(private http: HttpClient) { }

  GetChapters(type:string) : Observable<RestResponse> {
    let url:string = `${constant.HOME_URL}${API.Diagnosis.getChapters}`;
    url = url.replace('{type}',type);
    return this.http.get<RestResponse>(url);
  }

  SearchChapters(type:string,searchText:string) : Observable<RestResponse> {
    let url:string = `${constant.HOME_URL}${API.Diagnosis.searchChapters}`;
    url = url.replace('{type}',type).replace('{searchText}',searchText);
    return this.http.get<RestResponse>(url);
  }

  GetGroups(type:string,chapterId:number) : Observable<RestResponse> {
    let url:string = `${constant.HOME_URL}${API.Diagnosis.getGroups}`;
    url = url.replace('{type}',type).replace('{chapterId}',chapterId.toString());
    return this.http.get<RestResponse>(url);
  }

  SearchGroups(type:string,chapterId:number,searchText:string) : Observable<RestResponse> {
    let url:string = `${constant.HOME_URL}${API.Diagnosis.searchGroup}`;
    url = url.replace('{type}',type).replace('{chapterId}',chapterId.toString()).replace('{searchText}',searchText);
    return this.http.get<RestResponse>(url);
  }

  GetThreeDigitGrops(type:string, groupId:number) : Observable<RestResponse> {
    let url:string = `${constant.HOME_URL}${API.Diagnosis.getThreeDigitGrops}`;
    url = url.replace('{type}',type).replace('{groupId}',groupId.toString());
    return this.http.get<RestResponse>(url);
  }

  SearchThreeDigitGrops(type:string, groupId:number, searchText:string) : Observable<RestResponse> {
    let url:string = `${constant.HOME_URL}${API.Diagnosis.searchThreeDigitGrops}`;
    url = url.replace('{type}',type).replace('{groupId}',groupId.toString()).replace('{searchText}',searchText);
    return this.http.get<RestResponse>(url);
  }

  SearchDiagnosisCode(type:string, groupId:number, searchText:string) : Observable<RestResponse> {
    let url:string = `${constant.HOME_URL}${API.Diagnosis.searchDiagnosisCode}`;
    url = url.replace('{type}',type).replace('{groupId}',groupId.toString()).replace('{searchText}',searchText);
    return this.http.get<RestResponse>(url);
  }

  GetDiagnosisCodes(type:string,threeDigitCodeId:number): Observable<RestResponse> {
    let url:string =`${constant.HOME_URL}${API.Diagnosis.getDiagnosisCodeByTypeAndThreeDigitCodeId}`;
    url = url.replace('{type}',type).replace('{threeDigitId}',threeDigitCodeId.toString());
    return this.http.get<RestResponse>(url);
  }

  GetDiagnosisCode(type:string): Observable<RestResponse> {
    let url:string =`${constant.HOME_URL}${API.Diagnosis.getDiagnosisCodeByType}`;
    url = url.replace('{type}',type);
    return this.http.get<RestResponse>(url);
  }

  FindDiagnosisByCode(type:string,code:string): Observable<RestResponse> {
    let url:string =`${constant.HOME_URL}${API.Diagnosis.findDiagnosisByTypeAndCode}`;
    url = url.replace('{type}',type).replace('{code}',code);
    return this.http.get<RestResponse>(url);
  }


  ValidateDiagnosis(tipo:string,code:string):Observable<RestResponse> {
    let url:string = `${constant.HOME_URL}${API.Diagnosis.validateDiagnosisCode}`;
    url = url.replace('{tipo}',tipo).replace('{codigo}',code);
    return this.http.get<RestResponse>(url);
  }

  GetDiagnosisMinInfo(tipo:string,id:number,level:number):Observable<RestResponse> {
    let url:string = `${constant.HOME_URL}${API.Diagnosis.getDiagnosisMinInfo}`;
    url = url.replace('{tipo}',tipo).replace('{id}',id.toString()).replace('{level}',level.toString());
    return this.http.get<RestResponse>(url);
  }

  GetTreeView(tipo:string): Observable<RestResponse> {
    let url:string = `${constant.HOME_URL}${API.Diagnosis.getTreeView}`;
    url = url.replace('{tipo}',tipo);
    return this.http.get<RestResponse>(url);
  }

  GetRecordForDescriptionSearch(tipo:string,searchKey:string):Observable<RestResponse> {
    let url:string = `${constant.HOME_URL}${API.Diagnosis.searchCodesByDescription}`;
    url = url.replace('{tipo}',tipo).replace('{searchKey}',searchKey);
    return this.http.get<RestResponse>(url);
  }

}
